import { ConfirmationDialogContentHandle } from '@procureai/ui-mui';
import { forwardRef, useImperativeHandle, useRef } from 'react';

import { MessageForm } from '@/legacy/modules/DemandAwardingWidget/components/MessageForm/MessageForm';
import { MessageFormData } from '@/legacy/modules/DemandAwardingWidget/components/MessageForm/MessageForm.schema';
import { DemandAwardingSettings } from '@/legacy/modules/DemandAwardingWidget/DemandAwardingWidget.types';

import { AwardingConfirmationDialogContent } from './AwardingConfirmationDialog';

interface DemandLineItemAwardingConfirmationDialogProps {
  assignedAwardableLineItemsCount: number;
  dismissedAwardableLineItemsCount: number;
  awardingSettings: DemandAwardingSettings;
  numCases: number;
  onConfirm?: (data: MessageFormData) => void;
}

export const DemandLineItemAwardingConfirmationDialog = forwardRef<
  ConfirmationDialogContentHandle,
  DemandLineItemAwardingConfirmationDialogProps
>(function DemandLineItemAwardingConfirmationDialog(
  { assignedAwardableLineItemsCount, dismissedAwardableLineItemsCount, awardingSettings, numCases, onConfirm },
  ref,
) {
  const messageFormRef = useRef<ConfirmationDialogContentHandle>(null);

  useImperativeHandle(ref, () => ({
    confirm: async () => {
      messageFormRef.current?.confirm();
    },
  }));

  return (
    <div className="space-y-4">
      <MessageForm
        ref={messageFormRef}
        awardingSettings={awardingSettings}
        numCases={numCases}
        i18nKeyPrefix="DemandAwardingWidget.awardDialog"
        onConfirm={onConfirm}
        showDismissOtherSuppliers={false}
      />
      {dismissedAwardableLineItemsCount > 0 ? (
        <AwardingConfirmationDialogContent
          assignedAwardableLineItemsCount={assignedAwardableLineItemsCount}
          dismissedAwardableLineItemsCount={dismissedAwardableLineItemsCount}
          i18nKeyPrefix="DemandAwardingWidget.actions.award.confirmation"
        />
      ) : null}
    </div>
  );
});
